import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import DeleteIcon from '@commonComponents/deleteIcon'

const GuaranteeDetailForm = ({dataSource: {id,guaranteeType,guaranteeDesc},tableName,translate,guaranteeTypeList,onChange,onBlur,onSelect,deleteData}) => {
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const onDropDownChange=useCallback((e, {value,name})=>onSelect(id,tableName,{[name]:value,id}),[tableName,id,onSelect])
  const onBlurHandler=useCallback(({target:{value,name}})=>onBlur(tableName,{[name]:value,id}),[tableName,id,onBlur])
  
  return (
    <div  className="formContainer">   
   <Grid.Row>
      <Grid.Column>
        <DropDown
            id={`guaranteeType${id}`}
             name="guaranteeType"
            label={translate("GUARANTEE_TYPE", {ns:["default", "parties"]})}
            labelClass="text-none"
            data={guaranteeTypeList} 
            onChange={onDropDownChange}
            value={guaranteeType}
            text={guaranteeType}
          />
      </Grid.Column>
      <Grid.Column>
      <InputField
          id={`guaranteeDesc${id}`}
          type="text"
          name="guaranteeDesc"
          label={`${translate("GUARANTEE", {ns:["default", "parties"]})} ${translate("description", {ns:["default", "parties", "header"]})}`}
          clearInput={false}    
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          value={guaranteeDesc}
        />
    
      </Grid.Column>

    </Grid.Row>
    <div className="actionbtns">
    <DeleteIcon onClick={()=>deleteData(id,tableName)} />
    </div>
    </div>
  )
}
GuaranteeDetailForm.defaultProps = {
    translate:(value)=>value
  }
export default React.memo(GuaranteeDetailForm)
